enum LayoutSizes {
    SM = 480,
    TABLET = 768,
    DESKTOP = 1024,
}

export default LayoutSizes;
